import type { CSSProperties } from 'react';

export interface VeraMarkProps {
  size?: number;
  className?: string;
  style?: CSSProperties;
}

/**
 * VeraMark — friendly character mascot for the Vera platform.
 * A speech-bubble style cartoon head, PBS-Kids-inspired.
 */
export function VeraMark({ size = 32, className, style }: VeraMarkProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 48 48"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="Vera"
      className={className}
      style={style}
    >
      {/* Speech bubble background */}
      <circle cx="24" cy="22" r="20" fill="#FFF4E0" />
      {/* Bubble tail */}
      <circle cx="10" cy="40" r="3" fill="#FFF4E0" />
      <circle cx="5.5" cy="44" r="1.6" fill="#FFF4E0" />
      {/* Bubble highlight */}
      <ellipse cx="13" cy="11" rx="3" ry="2" fill="#FFFFFF" opacity="0.7" />

      {/* Hair — back blob (bob cut silhouette) */}
      <ellipse cx="24" cy="20" rx="13" ry="12" fill="#2D1F16" />

      {/* Face */}
      <ellipse cx="24" cy="24" rx="10" ry="10" fill="#F5C9A3" />

      {/* Bangs across the forehead */}
      <path
        d="M14 17 Q18 12 24 12 Q30 12 34 17 Q29 15 24 15 Q19 15 14 17 Z"
        fill="#2D1F16"
      />

      {/* Rosy cheeks */}
      <circle cx="17" cy="27" r="1.4" fill="#F5A5A5" opacity="0.55" />
      <circle cx="31" cy="27" r="1.4" fill="#F5A5A5" opacity="0.55" />

      {/* Eyes */}
      <circle cx="20.5" cy="23" r="1.5" fill="#1A1A1A" />
      <circle cx="27.5" cy="23" r="1.5" fill="#1A1A1A" />
      {/* Eye highlights */}
      <circle cx="21" cy="22.5" r="0.45" fill="#FFFFFF" />
      <circle cx="28" cy="22.5" r="0.45" fill="#FFFFFF" />

      {/* Smile */}
      <path
        d="M20 28 Q24 31.5 28 28"
        stroke="#1A1A1A"
        strokeWidth="1.6"
        strokeLinecap="round"
        fill="none"
      />
    </svg>
  );
}
